import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Article } from '@api/types/Article';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';



interface ArticleState {
	originalArticle: Article | null;
	guid: string | null;
	country: AppLanguageCode | null;
	url: string;
	name: string;
	content: string;
};

export const initialState: ArticleState = {
	originalArticle: null,
	guid: null,
	country: null,
	url: '',
	name: '',
	content: '',
};



export const articleSlice = createSlice({
	name: 'article',
	initialState,
	reducers: {
		setArticle: (state, action: PayloadAction<Article>) => {
			const article = action.payload;
			state.originalArticle = article;
			state.guid = article.guid;
			state.country = article.country;
			state.url = article.url;
			state.name = article.name;
			state.content = article.content;
		},
		resetArticle: (state) => {
			if (!state.originalArticle) return;
			state.url = state.originalArticle.url;
			state.name = state.originalArticle.name;
			state.content = state.originalArticle.content;
		},
		setUrl: (state, action: PayloadAction<string>) => {
			state.url = action.payload;
		},
		setName: (state, action: PayloadAction<string>) => {
			state.name = action.payload;
		},
		setContent: (state, action: PayloadAction<string>) => {
			state.content = action.payload;
		},
		resetStore: (_) => initialState,
	},
});



export const {
	setArticle,
	resetArticle,
	setUrl,
	setName,
	setContent,
	resetStore } = articleSlice.actions;